import React, { useEffect, useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { CiEdit } from "react-icons/ci";
import { MdDelete } from "react-icons/md";
import { FaRegFileLines, FaSpinner } from "react-icons/fa6";
import Swal from "sweetalert2";
import "./firmalar.css";
import { toast } from "react-toastify";
import { nodeURL } from "../configUrl";
import { normalizeName } from "../utils/similarity";

// Bir kiralamanın ürünlerinden (iade_mi bayrakları) gerçek durumunu türetir.
// Önceden bu sütun her satırda sabit "Hizmet Başlatıldı" yazıyordu.
const getDurum = (kiralama) => {
  const urunler = kiralama.urunler || [];
  if (urunler.length === 0) return { label: "Aktif", className: "bg-success" };
  const iadeSayisi = urunler.filter((u) => u.iade_mi).length;
  if (iadeSayisi === 0) return { label: "Aktif", className: "bg-success" };
  if (iadeSayisi === urunler.length) return { label: "İade Edildi", className: "bg-secondary" };
  return { label: "Kısmen İade Edildi", className: "bg-warning text-dark" };
};

const KiralamaListesi = () => {
  const navigate = useNavigate();
  const [searchTerm, setSearchTerm] = useState("");
  const [kiralamalar, setKiralamalar] = useState([]);
  const [loading, setLoading] = useState(true);
  const [loadingPdf, setLoadingPdf] = useState(false);

  const getInfos = () => {
    setLoading(true);
    axios
      .get(`${nodeURL}/getKiralamalar`)
      .then((response) => setKiralamalar(response.data))
      .catch(() => toast.error("Kiralama verisi bulunamadı!", { position: "top-right" }))
      .finally(() => setLoading(false));
  };

  useEffect(() => {
    getInfos();
  }, []);

  const handlePdfToplu = async () => {
    setLoadingPdf(true);
    try {
      const response = await axios.post(
        `${nodeURL}/topluPdfOlustur`,
        { getKiralamaListesi: kiralamalar },
        {
          responseType: "arraybuffer",
          headers: { "Content-Type": "application/json", Accept: "application/pdf" },
        }
      );
      const blob = new Blob([response.data], { type: "application/pdf" });
      window.open(window.URL.createObjectURL(blob));
    } catch (error) {
      toast.error("Toplu PDF indirilemedi!", { position: "top-right" });
    } finally {
      setLoadingPdf(false);
    }
  };

  const handleDelete = (id) => {
    Swal.fire({
      title: "Emin misiniz?",
      text: "Seçilen Kiralama silinecek!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Evet",
      cancelButtonText: "Vazgeç",
    }).then((result) => {
      if (result.isConfirmed) {
        axios
          .delete(`${nodeURL}/deletekiralama/${id}`)
          .then(() => {
            toast.success("Kiralama başarıyla silindi!", { position: "top-right" });
            getInfos();
          })
          .catch(() => toast.error("Silme sırasında hata oluştu!", { position: "top-right" }));
      }
    });
  };

  const filtered = kiralamalar.filter((k) => normalizeName(k.name).includes(normalizeName(searchTerm)));

  return (
    <div
      style={{
        background: "rgba(255, 255, 255, 0.2)",
        borderRadius: "15px",
        padding: "20px",
        backdropFilter: "blur(10px)",
        boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.2)",
      }}
      className="container-fluid"
    >
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          marginBottom: "10px",
          flexWrap: "wrap",
          gap: "10px",
        }}
      >
        <input
          type="text"
          placeholder="Firma Ara..."
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
          style={{
            padding: "8px",
            border: "1px solid #ccc",
            minWidth: "150px",
            borderRadius: "5px",
          }}
        />
        <h2 className="mt-2" style={{ marginRight: "20px", flexShrink: 0, whiteSpace: "nowrap" }}>
          Kiradaki Ürünler
        </h2>
        <div className="d-flex gap-2">
          <button
            className="btn btn-outline-danger"
            onClick={handlePdfToplu}
            disabled={loadingPdf}
          >
            {loadingPdf ? <FaSpinner className="fa-spin" /> : <FaRegFileLines className="me-1" />} Toplu PDF
          </button>
          <button className="btn btn-success" onClick={() => navigate("/home/kiradakiurunler/yeni")}>
            Yeni Kiralama
          </button>
        </div>
      </div>

      {loading ? (
        <div style={{ textAlign: "center", marginTop: "20px", fontSize: "16px" }}>Yükleniyor...</div>
      ) : filtered.length === 0 ? (
        <div
          style={{
            textAlign: "center",
            marginTop: "20px",
            padding: "10px",
            background: "#f8d7da",
            color: "#721c24",
            borderRadius: "5px",
            fontSize: "16px",
          }}
        >
          Listelenecek firma bulunamadı.
        </div>
      ) : (
        <div className="table-responsive">
          <table className="table table-striped table-bordered mt-3">
            <thead>
              <tr>
                <th style={{ width: "45%" }}>Firma Adı</th>
                <th>Durumu</th>
                <th>Kiralama Tarihi</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              {filtered.map((d) => {
                const durum = getDurum(d);
                return (
                  <tr key={d.id}>
                    <td>{d.name}</td>
                    <td>
                      <span className={`badge ${durum.className}`}>{durum.label}</span>
                    </td>
                    <td>{d.baslangic_tarihi}</td>
                    <td>
                      <div className="d-flex flex-wrap gap-2">
                        <button
                          className="btn btn-sm btn-secondary"
                          onClick={() => navigate(`/home/kiradakiurunler/${d.id}`)}
                        >
                          <CiEdit className="icon" size="18px" /> Düzenle
                        </button>
                        <button className="btn btn-sm btn-outline-danger" onClick={() => handleDelete(d.id)}>
                          <MdDelete className="icon" size="18px" /> Sil
                        </button>
                      </div>
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
};

export default KiralamaListesi;
